import { inject } from "@angular/core";
import { CanActivateFn, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { ImportTagsGuardService } from "@vp/tag-manager/feature";

export const ImportTagsGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  return inject(ImportTagsGuardService).canActivate();
};
